export var ValuationBlockFactorAdjustmentHeadingEnum;
(function (ValuationBlockFactorAdjustmentHeadingEnum) {
    ValuationBlockFactorAdjustmentHeadingEnum["Reasoning"] = "Reasoning";
    ValuationBlockFactorAdjustmentHeadingEnum["AdjustmentFactor"] = "Adjustment factor";
})(ValuationBlockFactorAdjustmentHeadingEnum || (ValuationBlockFactorAdjustmentHeadingEnum = {}));
export const ValuationBlockFactorAdjustmentConfigHeadingLookup = new Map([[ValuationBlockFactorAdjustmentHeadingEnum.Reasoning, "reasoning"], [ValuationBlockFactorAdjustmentHeadingEnum.AdjustmentFactor, "adjustmentFactor"]]);
